// extracted by mini-css-extract-plugin
export default {"Emojify":"bcf_a big_g"};